import flowElement from './flow/element'

const install = function (Vue) {
    Vue.directive('FShow', flowElement)
}

export default install
